<template>
  <b-modal size="sm" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

    <b-row>
      <b-col>
        <b-form >
          <b-card>
            <b-form-row>

              <b-form-textarea id="textarea-rows"  rows="8" max-rows="8" v-model="form.observacao"></b-form-textarea>


            </b-form-row>

            <b-form-row>

              <b-col cols="3"></b-col>
              <b-col cols="6" class="text-center">
                <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                  <b-icon icon="check-circle" />
                  <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                </b-button>

                <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                  <b-icon icon="x-circle" />
                  <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                </b-button>
              </b-col>
              <b-col cols="3"></b-col>

            </b-form-row>


          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>

import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";

export default {
  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },
  },
  mixins: [FormResourceMixin, ConfirmMixin],
  data() {
    return {
      title: "Observação",
      showModal: true,
      form: { descricao: "" },
    };
  },
  computed: {
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/historicocarga`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;

    }
  },
  methods: {
    cancelar() {
      this.$emit("close");
    },
    async save() {

      await this.$saveResource(this.form, "", false);
      this.cancelar();
    },
  },
};
</script>